/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';

const getLoadingStateFromStore = (state) => state.ui.loading;
const getPageTitleStateFromStore = (state) => state.ui.pageTitle;
const getPageSubtitleStateFromStore = (state) => state.ui.pageSubtitle;

const getSettingsSidebarStatusFromStore = (state) =>
  state.ui.settings.isSidebarOpen;

export const getLoadingState = () =>
  createSelector(getLoadingStateFromStore, (loadingState) => loadingState);

export const getPageTitle = () =>
  createSelector(getPageTitleStateFromStore, (pageTitle) => pageTitle || '');

export const getPageSubtitle = () =>
  createSelector(
    getPageSubtitleStateFromStore,
    (pageSubtitle) => pageSubtitle || ''
  );

export const isSettingsSidebarOpen = () =>
  createSelector(
    getSettingsSidebarStatusFromStore,
    (sidebarStatus) => sidebarStatus
  );

export const isLoggedAsCustomer = (state) => state.ui.isLoggedAsCustomer;
